<template>
  <div class="card">
    <div class="card-header">
      <p>{{ $t("operate") }}</p>
    </div>
    <div class="card-body">
      <el-row>
        <el-col :span="2" :offset="0">
          <el-button v-if="dir != '/'" @click="backClick">{{ $t("back") }}</el-button>
        </el-col>
        <el-col :span="1" :offset="0">
          <el-button @click="refreshList">{{ $t("refresh") }}</el-button>
        </el-col>
        <el-col :span="3">
          <el-upload :show-file-list="false" :action="null" :http-request="UploadData">
            <el-button v-show="Role.manageFile" type="primary">{{
              $t("upload")
              }}</el-button>
          </el-upload>
        </el-col>

        <el-col :span="2">
          <el-button @click="AddDirClick" v-show="Role.manageFile" type="primary">{{ $t("mkdir") }}</el-button>
        </el-col>

      </el-row>
    </div>
  </div>

  <div style="margin:-10px 0 10px 0;margin-left: 0;text-align: left; color: #999999;">
    {{ dir }}
  </div>


  <div :key="index" v-for="(element, index) in FileList">
    <li v-if="element.isdir == 0 && element.filename"
      style="padding: 10px; text-align: left;display: flex;flex-direction: row; align-items: center; margin: 3px 0;"
      class="list-group-item">
      <i style="font-size: 20px" class="fa fa-file-pdf-o"></i>
      <img class="icon" :src="element.icon" />
      <span style=" width: 500px; margin-left: 20px">
        <a style="font-size: 12px" @click="previewClick(element)" href="javascript:;">
          {{ element.filename }}
        </a>
      </span>

      <el-switch size="small" @change="changeDownloadStateClick(element)" v-if="Role.manageFile"
        style="margin-right:52px" inactive-color="#13ce66" active-color="red" v-model="element.candownload"
        active-text="需要审批" inactive-text="无需审批">
      </el-switch>

      <el-button type="primary" size="mini" style="height: 10px;" @click="previewClick(element)">
        {{ $t("preview") }}
      </el-button>

      <span style="margin: 0px 0px 0px 45px; width: auto;">
        <el-button size="mini" type="primary" @click="DownloadClick(element)">
          {{ downloadText(element) }}
        </el-button>
      </span>
      <el-button type="primary" size="mini" v-if="Role.manageFile" @click="renameClick(element)"
        style="margin: 0 0 0 50px">
        重命名

      </el-button>
      <el-button type="danger" size="mini" v-if="Role.manageFile" @click="DeleteItem(element)"
        style="margin:0 0 0 50px">{{
          $t("delete")
        }}
      </el-button>
    </li>

    <li v-if="element.isdir == 1 && element.filename"
      style="padding: 10px; text-align: left;display: flex;flex-direction: row; align-items: center; margin: 3px 0;"
      class="list-group-item">
      <i style="font-size: 20px" class="fa fa-folder-open"></i>
      <img class="icon" :src="element.icon" />
      <span style="display: inline-block; width: 500px; margin-left: 20px">
        <a style="font-size: 12px" @click="previewClick(element)" href="javascript:;">
          {{ element.filename }}
        </a>
      </span>

      <el-button type="primary" size="mini" v-if="Role.manageFile" @click="renameClick(element)"
        style="margin: 0 0 0 220px">
        重命名

      </el-button>
      <el-button size="mini" type="danger" v-if="Role.manageFile" @click="DeleteItem(element)"
        style="margin: 0 50px 0">{{
          $t("delete")
        }}
      </el-button>
    </li>
  </div>

  <el-dialog v-model="uploadShow" :close-on-click-modal="false" :fullscreen="false">
    <el-row>
      <el-col :span="6"></el-col>
      <el-col :span="12">
        <el-input v-model="fileName" placeholder="请输入文件名">
          <template #prepend>文件名</template>
        </el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10"></el-col>
      <el-col :span="3">
        <el-checkbox v-model="canDownload" label="下载需审批" />
      </el-col>
    </el-row>
    <br />
    <el-row :gutter="10">
      <el-col :span="9"></el-col>
      <el-col :span="2">
        <el-button @click="upload2server" type="primary">确定</el-button>
      </el-col>

      <el-col :span="4">
        <el-button @click="
          uploadShow = false;
        canDownload = false;
        ">取消</el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { file } from "@babel/types";
import { urlencoded } from "body-parser";
import { userInfo } from "os";
import Swal from "sweetalert2";
import {
  GetAllFiles,
  UploadFile,
  DeleteFile,
  RequestDownload,
  AddDir,
  ChangeDownloadState,
  SendDownloadLog,
  RenameFile
} from "../../common/httphelper";
import getRole from "../../common/role";

const OSS = require("ali-oss");

const client = new OSS({
  // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
  region: "oss-cn-guangzhou",
  // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
  accessKeyId: "LTAItdKUSj0MOUTc",
  accessKeySecret: "LhqjeZY9lC4rpAStCEMAIir7v6kFhp",
  // 刷新临时访问凭证的时间间隔，单位为毫秒。
  refreshSTSTokenInterval: 300000,
  // 填写Bucket名称。
  bucket: "motinova-admin",
});

export default {
  components: {},
  data() {
    return {
      FileList: [],
      dir: "",
      uploadShow: false,
      fileName: "",
      canDownload: false,
      uploadFileUrl: "",
      Role: {},
      lastdir: [],
    };
  },
  methods: {

    async renameClick(file) {
      console.log(file)
      await Swal.fire({
        title: "重命名",
        input: "text",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: true,
        inputValue: file.filename,

      }).then(async (res) => {
        if (res.value) {
          await RenameFile(file, res.value).then(resp => {
            if (resp.data) {
              this.refreshList()
            }
          }
          )
        }
      }
      )
    },


    async UploadData(file) {
      try {
        Swal.fire({
          title: "上传中...",
          html: "请稍候...",
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
        Swal.showLoading();
        // object表示上传到OSS的文件名称。
        // file表示浏览器中需要上传的文件，支持HTML5 file和Blob类型。
        const r1 = await client.put(
          this.dir + Math.random().toString(36).substr(2) + file.file.name,
          file.file
        );
        this.uploadFileUrl = r1.url;
        Swal.close();
        this.fileName = file.file.name;
        this.uploadShow = true;
      } catch (e) {
        console.error("error: %j", e);
      }
    },

    changeDownloadStateClick(item) {
      ChangeDownloadState(item.id).then(res => {
        item.candownload = res.data
      })
    },

    previewClick(item) {
      if (item.isdir == 1) {
        this.lastdir.push(this.dir);
        this.dir = this.dir + item.filename + "/";
        this.refreshList();
        return;
      }


      if (['xlxs', 'doc', 'docx', 'pptx'].filter(x => item.filename.endsWith(x)).length) {
        // let url = this.$router.resolve({
        //   path: 'PdfViewer', query: {
        //     url: window.btoa(item.fileurl)
        //   }
        // })

        window.open('https://view.officeapps.live.com/op/embed.aspx?src=' + (item.fileurl), '_blank')

        return;
      }

      window.open(
        item.fileurl
      );

      return;
    },

    backClick() {
      if (this.lastdir.length < 1) {
        this.$router.back();
      } else {
        this.dir = this.lastdir.pop();
        this.refreshList();
      }
    },

    async upload2server() {
      if (!this.fileName) {
        this.uploadShow = false;
        await Swal.fire({
          icon: "error",
          title: "请填写文件名",
          showConfirmButton: false,
          timer: 3000,
        });
        this.uploadShow = true;
        return;
      }

      UploadFile({
        filename: this.fileName,
        fileurl: this.uploadFileUrl,
        candownload: this.canDownload,
        prefix: this.dir,
      }).then(async (res) => {
        if (res.data) {
          this.uploadShow = false;
          await Swal.fire({
            icon: "success",
            title: "上传成功",
            showConfirmButton: false,
            timer: 3000,
          });
          this.refreshList();
        } else {
          this.uploadShow = false;
          await Swal.fire({
            icon: "error",
            title: "文件已存在！",
            showConfirmButton: false,
            timer: 3000,
          });
          this.uploadShow = true;
        }
      });
    },

    async DeleteItem(item) {
      // 指定待删除的Object的名称。Object名称需填写不包含Bucket名称在内的Object的完整路径，例如exampledir/exampleobject.txt。
      await DeleteFile(item.id).then(async (res) => {
        let that = this;
        if (res.data) {
          await Swal.fire({
            icon: "success",
            title: that.$t('approvetip'),
            showConfirmButton: false,
            timer: 3000,
          });
          this.refreshList();
        } else {
          await Swal.fire({
            icon: "warning",
            title: that.$t('waitforapprove'),
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
    },
    async AddDirClick() {
      const { value: name } = await Swal.fire({
        title: "输入文件夹名",
        input: "text",
        inputPlaceholder: "文件夹名",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
        allowOutsideClick: false,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      });
      if (!name) {
        return;
      }
      AddDir({
        filename: name,
        isdir: 1,
        prefix: this.dir,
      }).then(async (res) => {
        if (res.data) {
          this.uploadShow = false;
          await Swal.fire({
            icon: "success",
            title: "上传成功",
            showConfirmButton: false,
            timer: 3000,
          });
          this.refreshList();
        } else {
          this.uploadShow = false;
          await Swal.fire({
            icon: "error",
            title: "文件夹已存在！",
            showConfirmButton: false,
            timer: 3000,
          });
          this.uploadShow = true;
        }
      });
    },
    refreshList() {
      this.fileName = "";
      this.canDownload = false;

      Swal.fire({
        title: "加载中...",
        html: "请稍候...",
        allowEscapeKey: false,
        allowOutsideClick: false,
      });
      Swal.showLoading();

      GetAllFiles(this.dir).then((res) => {
        this.FileList = res.data;
        Swal.close();
      });
    },
    DownloadClick(item) {
      let that = this;
      if (item.candownload) {
        RequestDownload(item.id).then((res) => {
          if (res.data == "allow") {
            Swal.fire({
              title: "加载中...",
              html: "请稍候...",
              allowEscapeKey: false,
              allowOutsideClick: false,
            });
            Swal.showLoading();

            fetch(item.fileurl, {
              method: "GET",
            })
              .then((resp) => resp.blob())
              .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = url;
                a.download = item.filename; // the filename you want
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                Swal.close();
              });
          }

          if (res.data == "requested") {
            Swal.fire({
              icon: "success",
              title: that.$t('approvetip'),
              showConfirmButton: false,
              timer: 3000,
            });
          }

          if (res.data == "requesting") {
            Swal.fire({
              icon: "warning",
              title: that.$t('waitforapprove'),
              showConfirmButton: false,
              timer: 3000,
            });
          }
        });
      } else {
        Swal.fire({
          title: "Loading...",
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
        Swal.showLoading();

        fetch(item.fileurl, {
          method: "GET",
        })
          .then((resp) => resp.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = item.filename; // the filename you want
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            Swal.close();
          });

        SendDownloadLog(item.id)
      }
    },
    downloadText(item) {
      if (item.candownload) {
        if (item.allow_download_user === null || !item.allow_download_user.includes(sessionStorage.getItem("id"))) {
          if (this.$i18n.locale == "中文") return "申请下载";
          return "Apply for download";
        }
      }
      if (this.$i18n.locale == "中文") return "下载";
      return "Download";
    },
  },
  mounted() {
    this.dir = this.$route.query.catlog;
    this.refreshList();
    this.Role = getRole();
  },
};
</script>

<style scoped>
a {
  cursor: pointer;
}
</style>

<style>
.el-switch__label {
  color: #DDD;
}
</style>